<template>
    <section class="section h-s-f">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-xl-6">
                    <div class="section__header wow fadeInUp" data-wow-duration="600ms" data-wow-delay="300ms">
                        <h2 class="h2">client's feedback</h2>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="h-s-f-inner">
                        <div class="h-s-f-single">
                            <h4>Rate us</h4>
                            <img :src="require('@/assets/images/home-six/quote.png')" alt="Image">
                            <div class="d-flex gr">
                                <div class="review__icons">
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                </div>
                                <h4>
                                    4.7
                                    <span>/ 5</span>
                                </h4>
                            </div>
                        </div>
                        <div class="h-s-f-single">
                            <p class="text-md fw-7">Need Single page site design</p>
                            <blockquote>
                                <q>"He is a good designer with UI/UX experience. He has compiled my landing page in a
                                    good looking way."</q>
                            </blockquote>
                            <div class="rti">
                                <div class="review__icons">
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                </div>
                                <p>
                                    <span>luwise</span>
                                    london, UK
                                </p>
                            </div>
                        </div>
                        <div class="h-s-f-single brt">
                            <p class="text-md fw-7">Need Single page site design</p>
                            <blockquote>
                                <q>"He is a good designer with UI/UX experience. He has compiled my landing page."</q>
                            </blockquote>
                            <div class="rti">
                                <div class="review__icons">
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                </div>
                                <p>
                                    <span>luwise</span>
                                    london, UK
                                </p>
                            </div>
                        </div>
                        <div class="h-s-f-single brt">
                            <p class="text-md fw-7">Need Single page site design</p>
                            <blockquote>
                                <q>"He is a good designer with UI/UX experience. He has compiled my landing page."</q>
                            </blockquote>
                            <div class="rti">
                                <div class="review__icons">
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                </div>
                                <p>
                                    <span>luwise</span>
                                    london, UK
                                </p>
                            </div>
                        </div>
                        <div class="h-s-f-single">
                            <p class="text-md fw-7">Need Single page site design</p>
                            <blockquote>
                                <q>"He is a good designer with UI/UX experience. He has compiled my landing page in a
                                    good looking way."</q>
                            </blockquote>
                            <div class="rti">
                                <div class="review__icons">
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                </div>
                                <p>
                                    <span>luwise</span>
                                    london, UK
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Feedback",
    }
</script>


// WEBPACK FOOTER //
// src/components/page_components/home-6/Feedback.vue